<template>
    <sys-teacher-hub-modal
        :show="show"
        @update:show="$emit('update:show', $event)"
        :title="title"
        :icon="icon"
        max-width="820"
    >
        <v-card-text class="pa-0">
            <sys-teacher-work-load-confirm
                :teacher="teacher"
                :work-time="workTime"
                :token="token"
                :allow-actions="true"
                @onComplete="handleComplete"
            />
        </v-card-text>
    </sys-teacher-hub-modal>
</template>

<script>
export default {
    name: 'SysTeacherWorkLoadConfirmHub',
    props: {
        show: {
            type: Boolean,
            default: false
        },
        teacher: {
            type: Object,
            default: () => ({})
        },
        workTime: {
            type: Object,
            default: () => ({})
        },
        token: {
            type: String,
            default: null
        },
        icon: {
            type: String,
            default: 'mdi-checkbox-marked-outline'
        },
        title: {
            type: String,
            default: 'Confirmação de Carga Horária'
        }
    },
    methods: {
        handleComplete(event) {
            this.$emit('onComplete', event)
        }
    }
}
</script>
